import React from "react";
import { NextSeo } from "next-seo";
export default function Seo({ seo }) {
  const {
    slug = "#",
    metaTitle = "Interior Designing Firm | Interior Design Studio",
    metaDescription = "Chalk Studio, an interior designing firm provides customized interior design solutions for residential & commercial spaces.",
    metaImage = "/logo.png",
  } = seo;
  return (
    <NextSeo
      title={metaTitle}
      description={metaDescription}
      url={`https://www.chalkstudio.design/${slug}`}
      canonical={`https://www.chalkstudio.design/${slug}`}
      openGraph={{
        type: "website",
        locale: "en_IE",
        site_name: "Chalk Studio",
        url: `https://www.chalkstudio.design/${slug}`,
        title: metaTitle,
        description: metaDescription,
        images: [
          {
            url: metaImage,
            width: 140,
            height: 140,
            alt: "Chalk Studio",
          },
        ],
      }}
    />
  );
}
